<template>
  <div class="!pb-0">
    <div class="absolute ml-9">
      <Logo />
    </div>
    <div class="flex flex-col justify-end h-screen ml-9">
      <div class="flex flex-row my-auto">
        <LoginBox />
      </div>
      <div class="flex justify-end">
        <span class="text-proxify-black text-heading-3 px-8 pb-4">
          Made with ❤️ by Proxify
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import Logo from '@/components/Elements/Logo.vue';
import LoginBox from '@/components/Elements/Login/LoginBox.vue';
import titleMixin from '@/mixins/titleMixin';

export default {
  name: 'TheLogin',
  title: 'Login',
  components: {
    Logo,
    LoginBox,
  },
  mixins: [titleMixin],
};
</script>
